
















import {defineComponent} from "@vue/composition-api";
import ThemeBlock from "@base/Components/theme/ThemeBlock.vue";

export default defineComponent({
    components: {
        ThemeBlock
    },
    emits: ['submitted'],
    props: {
      loading: {
          type: Boolean,
          default: false
      }
    },
    setup(props, {slots}) {
        const hasActions = !!slots.actions;

        return {
            hasActions
        }
    }
})
